// Generic fetch function for non-CMS endpoints
export async function fetchData(
  endpoint: string,
  params?: Record<string, string | number>,
  method: "GET" | "POST" | "DELETE" = "GET",
  body?: Record<string, unknown>,
  withCredentials: boolean = false,
) {
  const baseUrl = import.meta.env.PUBLIC_BACKEND_BASE_URL;
  const url = new URL(`${baseUrl}/${endpoint}`);

  if (params && method === "GET") {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, String(params[key])),
    );
  }

  try {
    const response = await fetch(url.toString(), {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      body:
        method === "POST" || method === "DELETE" ? JSON.stringify(body) : null,
      credentials: withCredentials ? "include" : "same-origin", // Handle cookies if needed
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Failed to fetch data:", error);
    throw new Error(
      error instanceof Error ? error.message : "An unknown error occurred",
    );
  }
}

// Universities data fetch for non-CMS endpoints
export async function fetchUniversitiesData(
  endpoint: string,
  params?: Record<string, string | number>,
) {
  const baseUrl = import.meta.env.PUBLIC_BACKEND_CMS_BASE_URL;
  const url = new URL(`${baseUrl}/${endpoint}`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, String(params[key])),
    );
  }

  try {
    const response = await fetch(url.toString());
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch data:", error);
    return null;
  }
}
